
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectsDeleteHeadline: {
    id: "ProjectsDelete.headline",
    defaultMessage: "Are you sure you want to delete your project?",
  }, 
  projectsDeleteButton: {
    id: "ProjectsDelete.button",
    defaultMessage: "Accept",
  }, 
});

export default MESSAGES;